import React, { useState, useEffect } from 'react';
import './Lotoreyalar.css';
import moment from 'moment';
import 'moment/locale/az';
import LotoreyaController from '../../../api/lotoreya/LotoreyaController';
import ElanController from '../../../api/elan/ElanController';
import { useNavigate } from 'react-router-dom'; // Əlavə edin (əvvəldə)
import UserController from '../../../api/user/UserController';

const Lotoreyalar = () => {
    const [lotoreyas, setLotoreyas] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate(); // Komponentin içində istifadə edin
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedLotoreya, setSelectedLotoreya] = useState(null);
    const [editBiletPrice, setEditBiletPrice] = useState('');
    const [editLotoreyaDate, setEditLotoreyaDate] = useState('');

    const pendingCount = lotoreyas.filter(l => l.isAccept === false).length;

    useEffect(() => {
        const loadLotoreyas = async () => {
            try {
                const all = await LotoreyaController.getAllLotoreyas();

                // Elan məlumatlarını əlavə edək
                for (let lotoreya of all) {
                    const elan = await ElanController.getElanById(lotoreya.elanId);
                    lotoreya.elan = elan;

                    if (!lotoreya.carx && lotoreya.id) {
                        try {
                            const fullLotoreya = await LotoreyaController.getLotoreyaById(lotoreya.id);
                            lotoreya.carx = fullLotoreya.carx;
                        } catch (err) {
                            console.warn("carx məlumatı yüklənə bilmədi:", err);
                        }
                    }

                    // 🆕 Qalibin adı üçün əlavə yükləmə
                    if (lotoreya.carx?.winnerUserId) {
                        try {
                            const winnerUser = await UserController.getUserById(lotoreya.carx.winnerUserId);
                            lotoreya.carx.winnerUser = winnerUser;
                        } catch (e) {
                            console.warn("Qalib istifadəçi tapılmadı", e);
                        }
                    }
                }

                setLotoreyas(all);
            } catch (error) {
                console.error('Lotoreyalar yüklənərkən xəta:', error);
            } finally {
                setIsLoading(false);
            }
        };

        loadLotoreyas();
    }, []);

    // Filter: isAccept === true və sort by lotoreyaDate (ən yaxın yuxarıda)
    const acceptedLotoreyas = lotoreyas
        .filter(l => l.isAccept === true && l.lotoreyaDate)
        .filter(l => l.elan?.title?.toLowerCase().includes(searchTerm.toLowerCase()))
        .sort((a, b) => {
            const aIsFinished = a.carx?.winnerUserId ? 1 : 0;
            const bIsFinished = b.carx?.winnerUserId ? 1 : 0;

            // Əvvəl aktivlər, sonra bitmişlər. Tarixə görə sort.
            if (aIsFinished !== bIsFinished) return aIsFinished - bIsFinished;
            return new Date(a.lotoreyaDate) - new Date(b.lotoreyaDate);
        });

    const handleBack = () => {
        navigate(-1); // Geri getmək üçün bu funksiyanı istifadə edirik
    };

    const openEditModal = (lotoreya) => {
        setSelectedLotoreya(lotoreya);
        setEditBiletPrice(lotoreya.biletPrice);
        setEditLotoreyaDate(lotoreya.lotoreyaDate ? lotoreya.lotoreyaDate.substring(0, 10) : ''); // YYYY-MM-DD format
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedLotoreya(null);
    };

    return (
        <div className="lotoreyalar-container">
            <h2>Lotoreyalar</h2>

            <button onClick={handleBack} className="back-button">
                Geri
            </button>

            {/* Axtarış */}
            <input
                type="text"
                className="search-input"
                placeholder="Axtarış..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />

            <button
                className="pending-button"
                onClick={() => navigate('/private/lotoreya/istekler')}
            >
                Lotoreya İstəkləri ({pendingCount})
            </button>

            {showEditModal && selectedLotoreya && (
                <div className="modal-backdrop">
                    <div className="modal-content">
                        <h3>Lotoreyanı Düzəlt</h3>

                        {/* Bilet Qiyməti */}
                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '10px' }}>
                            Bilet Qiyməti (₼):
                            <input
                                type="number"
                                step="0.01"
                                min="1"
                                value={editBiletPrice}
                                onChange={(e) => setEditBiletPrice(e.target.value)}
                                style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}
                            />
                        </label>

                        {/* Lotoreya Tarixi */}
                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '10px' }}>
                            Lotoreya Tarixi:
                            <input
                                type="date"
                                value={editLotoreyaDate}
                                onChange={(e) => setEditLotoreyaDate(e.target.value)}
                                style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}
                            />
                        </label>

                        {/* Toplam Bilet Sayı */}
                        <label style={{ display: 'block', textAlign: 'left', marginBottom: '10px' }}>
                            Toplam Bilet Sayı:
                            <input
                                type="number"
                                min="1"
                                max="99999"  // Maksimum 99999 olmalıdır
                                value={selectedLotoreya.totalBiletCount || ''}
                                onChange={(e) => {
                                    // Girişə 5 rəqəm məhdudiyyəti əlavə etmək
                                    const value = e.target.value;
                                    if (value.length <= 5) {
                                        setSelectedLotoreya(prev => ({
                                            ...prev,
                                            totalBiletCount: parseInt(value) || 0
                                        }));
                                    }
                                }}
                                style={{ width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc' }}
                            />
                        </label>

                        <button className="confirm-btn" onClick={async () => {
                            try {
                                await LotoreyaController.updateLotoreya(selectedLotoreya.id, {
                                    biletPrice: parseFloat(editBiletPrice),
                                    lotoreyaDate: editLotoreyaDate,
                                    totalBiletCount: selectedLotoreya.totalBiletCount
                                });

                                alert('✅ Düzəliş saxlanıldı!');

                                // Local list-i yenilə
                                setLotoreyas(prev =>
                                    prev.map(l =>
                                        l.id === selectedLotoreya.id
                                            ? { ...l, biletPrice: parseFloat(editBiletPrice), lotoreyaDate: editLotoreyaDate, totalBiletCount: selectedLotoreya.totalBiletCount }
                                            : l
                                    )
                                );

                                closeEditModal();
                            } catch (error) {
                                console.error('Düzəliş zamanı xəta:', error);
                                alert('Xəta baş verdi, yenidən cəhd edin.');
                            }
                        }}>
                            Yadda Saxla
                        </button>

                        <button className="cancel-btn" onClick={closeEditModal}>
                            Bağla
                        </button>
                    </div>
                </div>
            )}

            {isLoading ? (
                <div className="loading">Yüklənir...</div>
            ) : acceptedLotoreyas.length === 0 ? (
                <div className="no-lotoreya">Hazırda aktiv lotoreya yoxdur.</div>
            ) : (
                <div className="lotoreya-list">
                    {acceptedLotoreyas.map(lotoreya => (
                        <div key={lotoreya.id} className="lotoreya-card">
                            <img
                                src={lotoreya.elan?.image}
                                alt={lotoreya.elan?.title}
                                className="lotoreya-image"
                            />

                            {/* Elana Bax düyməsi */}
                            <div style={{ marginTop: '10px', textAlign: 'center' }}>
                                <button
                                    onClick={() => navigate(`/private/elan/${lotoreya.elan?.id}`)}
                                    className="view-elan-btn"
                                >
                                    Elana Bax
                                </button>
                            </div>

                            <div className="lotoreya-info">
                                <h3>{lotoreya.elan?.title}</h3>
                                <p>
                                    <strong>Lotoreya Tarixi:</strong>{' '}
                                    {moment(lotoreya.lotoreyaDate).locale('az').format('LL')}
                                </p>
                                <p>
                                    <strong>Bilet Qiyməti:</strong> {lotoreya.biletPrice} ₼
                                </p>
                                <p>
                                    <strong>Toplam Bilet Sayı:</strong> {lotoreya.totalBiletCount}
                                </p>
                            </div>

                            <div style={{ marginTop: '12px' }}>
                                {(() => {
                                    const soldCount = lotoreya.bilets ? lotoreya.bilets.length : 0;
                                    const totalCount = lotoreya.totalBiletCount || 1; // sıfıra bölməmək üçün
                                    const percent = Math.min(100, Math.round((soldCount / totalCount) * 100));

                                    return (
                                        <>
                                            <p>Satılan: {percent}%</p>
                                            <div style={{
                                                background: '#eee',
                                                borderRadius: '8px',
                                                overflow: 'hidden',
                                                height: '10px'
                                            }}>
                                                <div style={{
                                                    width: `${percent}%`,
                                                    background: 'orange',
                                                    height: '10px'
                                                }} />
                                            </div>
                                            <p>Satılan Bilet Sayı: {soldCount} / {totalCount}</p> {/* Satılan bilet sayı buraya əlavə olunur */}
                                        </>
                                    );
                                })()}
                            </div>

                            {/* Qazanılmış məbləğ */}
                            {lotoreya.soldTickets !== undefined && lotoreya.biletPrice && (
                                <p style={{ marginTop: '8px', fontWeight: 'bold' }}>
                                    Qazanılmış məbləğ: {(lotoreya.soldTickets * lotoreya.biletPrice).toFixed(2)} ₼
                                </p>
                            )}

                            <div style={{ marginTop: '12px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                                {lotoreya.carx?.winnerUserId ? (
                                    <div style={{ color: 'red', fontWeight: 'bold' }}>
                                        ✅ Lotoreya artıq başa çatıb <br />
                                        👤 Qalib:{' '}
                                        {lotoreya.carx.winnerUser ? (
                                            <a
                                                href={`/private/istifadeciler/${lotoreya.carx.winnerUserId}`}
                                                style={{
                                                    color: '#2980b9',
                                                    textDecoration: 'underline',
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {lotoreya.carx.winnerUser.name}
                                            </a>
                                        ) : (
                                            <span style={{ color: '#2c3e50' }}>İstifadəçi tapılmadı</span>
                                        )}
                                    </div>
                                ) : (
                                    <button
                                        className="spin-btn"
                                        onClick={() => navigate(`/private/lotoreya/carx/${lotoreya.id}`)}
                                    >
                                        🎰 Çarxı Fırlat
                                    </button>
                                )}

                                <button
                                    className="edit-btn"
                                    onClick={() => openEditModal(lotoreya)} // Edit Modal açacaq funksiya
                                >
                                    ✏️ Lotoreyanı Düzəlt
                                </button>

                                <button
                                    className="delete-btn"
                                    onClick={async () => {
                                        if (window.confirm('Lotoreyanı ləğv etmək istəyirsiniz?')) {
                                            try {
                                                await LotoreyaController.deleteLotoreyaById(lotoreya.id);
                                                alert('✅ Lotoreya ləğv edildi!');
                                                setLotoreyas(prev => prev.filter(l => l.id !== lotoreya.id));
                                            } catch (error) {
                                                console.error('Lotoreya silinərkən xəta:', error);
                                                alert('Xəta baş verdi, yenidən cəhd edin.');
                                            }
                                        }
                                    }}
                                >
                                    ❌ Lotoreyanı Ləğv Et
                                </button>
                            </div>

                        </div>

                    ))}
                </div>
            )}
        </div>
    );
};

export default Lotoreyalar;

